module.exports = __webpack_public_path__ + "static/no-webcam-filler-60dd333f736c16970195919c544422a4.webp";